var render, staticRenderFns
import script from "./BulkOperation.vue?vue&type=script&lang=js&"
export * from "./BulkOperation.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperation.vue?vue&type=style&index=0&id=826a4d56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826a4d56",
  null
  
)

export default component.exports